// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.client.phoneverifier.enums.PhoneVerificationSource

export enum PhoneVerificationSource {
  ADMIN = 'admin',
  LISTING_CLAIMING_PATH = 'listingClaimingPath',
  LISTING_CONTACT = 'listingContact',
  OTP_RENT_PAYMENT = 'otpRentPayment',
}

export const PhoneVerificationSource_values = [
  PhoneVerificationSource.ADMIN,
  PhoneVerificationSource.LISTING_CLAIMING_PATH,
  PhoneVerificationSource.LISTING_CONTACT,
  PhoneVerificationSource.OTP_RENT_PAYMENT,
] as const;
